import { Button } from "@payping/web-components";
import classNames from "classnames";
import React from "react";
import styles from "../../../assets/scss/Plan.module.scss";
import { useAppSelector } from "../../../utils/redux";

export const PlanButton: React.FC = () => {
  const currentPlan = useAppSelector((state) => state.user.panelInfo?.currentPlan);

  return (
    <Button size={"small"} className={classNames(styles.upgradeButton)} variant={"primary"}>
      {currentPlan?.title}
    </Button>
  );
};
